const createHistory = require('history').createBrowserHistory

const history = createHistory()

export default history



// WEBPACK FOOTER //
// ./src/history.ts